import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'outline' | 'gradient';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-forest-100 text-forest-800 border border-forest-200',
    success: 'bg-gradient-to-r from-forest-500 to-forest-600 text-white shadow-md',
    warning: 'bg-gradient-to-r from-ember-400 to-ember-500 text-white shadow-md',
    outline: 'border-2 border-forest-700 text-forest-800 bg-transparent font-semibold',
    gradient: 'bg-gradient-to-r from-forest-600 via-forest-500 to-ember-500 text-white shadow-lg'
  };
  return <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${variants[variant]} ${className}`} data-id="element-135">
      {children}
    </span>;
}